module.exports = __webpack_public_path__ + "img/jyhd-dabiao-2@3x.498dd4b6.png";